module.exports = __webpack_public_path__ + "static/008641-7192fe78b5127d01a4e25f5556d6d983.jpg";